export class GenericOption {
  constructor(public value: string, public display: string) {}
}
